import create from "../utils/create";
import loading from "../loading";
var URL_OPTIONS = {
  smartGuideUrl: "//g.alicdn.com/sd/nvc/1.1.112/guide.js?t=2015052012",
  smartCaptchaUrl: "//g.alicdn.com/sd/smartCaptcha/0.0.4/index.js",
  sliderUrl: "//g.alicdn.com/sd/nch5/index.js?t=2015052012"
};
var ERROR_TEXT = {
  NOTFOUND: "网络环境差，请稍后重试",
  INITERROR: "初始化失败，请稍后重试"
};
var ERROR_TYPE = {
  LOADFAIL: "LOADFAIL",
  INITFAIL: "INITFAIL",
  VERIFYFAIL: "VERIFYFAIL"
};
export default create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [this.loading ? _c('loading', {
      staticClass: "verify_loading",
      attrs: {
        "size": "100px",
        "type": "pointloading"
      }
    }) : _vm._e(), this.error ? _c('div', {
      staticClass: "verify_msg"
    }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _c('div', [this.type === 1 ? _c('div', {
      attrs: {
        "id": "sc"
      }
    }) : _vm._e(), this.type === 2 ? _c('div', {
      attrs: {
        "id": "__nc"
      }
    }, [_c('div', {
      attrs: {
        "id": "nc"
      }
    })]) : _vm._e()])], 1);
  },
  name: "verify",
  props: {
    /**
     * @param {Number} type 初始化验证码类型，1=>ic 智能|2=>nc 滑块
     */
    type: {
      type: Number
    },

    /**
     * @param {String} appkey 应用类型标识
     */
    appkey: {
      type: String
    },

    /**
     * @param {String} scene 使用场景标识
     */
    scene: {
      type: String
    },

    /**
     * @param {String} token 验证token
     */
    token: {
      type: String
    }
  },
  data: function data() {
    return {
      loading: false,
      error: false,
      errorMsg: "",
      errorType: ""
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.componentInit();
  },
  methods: {
    /**
     * 错误处理方法
     * @param {Error} error   error对象
     * @param {String} msg   error报错文案
     * @param {String} type   error报错类型
     */
    handleError: function handleError(error, msg, type) {
      if (error) {
        this.error = true;

        if (type === ERROR_TYPE.LOADFAIL || this.errorType === ERROR_TYPE.LOADFAIL) {
          this.errorMsg = ERROR_TEXT.NOTFOUND;
          this.errorType = type;
        } else {
          this.errorMsg = msg || "数据异常，请稍后再试";
        }

        var eventEntity = {
          error: error,
          errorType: type,
          errorMsg: this.errorMsg
        };
        this.$emit("callback", eventEntity, null);
        this.loading = false;
        window._fas && window._fas.setCustomError({
          message: this.errorMsg,
          error: error
        });
      }
    },

    /**
     * 异步加载script
     * @param {string} url   script src路径
     * @returns {promise}
     */
    asyncLoadScript: function asyncLoadScript(url) {
      var that = this;
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
          //IE
          script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
              script.onreadystatechange = null;
              resolve();
            }
          };
        } else {
          //Others: Firefox, Safari, Chrome, and Opera
          script.onload = function () {
            resolve();
          };

          script.onerror = function (err) {
            that.handleError(err, ERROR_TEXT.NOTFOUND, ERROR_TYPE.LOADFAIL);
            reject(err);
          };
        }

        script.src = url;
        document.body.appendChild(script);
      });
    },
    // 组件初始化
    componentInit: function componentInit() {
      var _this = this;

      this.loading = true;

      if (this.type === 2) {
        // 滑块init
        this.asyncLoadScript(URL_OPTIONS.sliderUrl).then(function () {
          _this.sliderInit();
        }).catch(function (err) {
          _this.handleError(err, ERROR_TEXT.INITERROR, ERROR_TYPE.INITFAIL);
        }).finally(function () {
          _this.loading = false;
        });
      } else if (this.type === 1) {
        // 智能init
        this.asyncLoadScript(URL_OPTIONS.smartCaptchaUrl).then(function () {
          _this.initNVC();

          _this.asyncLoadScript(URL_OPTIONS.smartGuideUrl).then(function () {
            _this.smartInit();
          });
        }).catch(function (err) {
          _this.handleError(err, ERROR_TEXT.INITERROR, ERROR_TYPE.INITFAIL);
        }).finally(function () {
          _this.loading = false;
        });
      } else {
        // 默认情况
        this.loading = false;
      }
    },
    // 智能验证码初始化
    smartInit: function smartInit() {
      var that = this;

      try {
        window.NVC_Opt.token = this.token;
        var ic = new smartCaptcha({
          // 声明智能验证需要渲染的目标元素ID。
          renderTo: "#sc",
          // 智能验证组件的宽度。
          width: "100%",
          // 智能验证组件的高度。
          height: 42,
          // 智能验证组件初始状态文案。
          default_txt: "点击按钮开始智能验证",
          // 智能验证组件验证通过状态文案。
          success_txt: "验证成功",
          // 智能验证组件验证失败（拦截）状态文案。
          fail_txt: "验证失败，请再次点击",
          // 智能验证组件验证中状态文案。
          scaning_txt: "智能检测中",
          // 前端智能验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          success: function success(data) {
            this.error = false;
            that.$emit("callback", null, {
              data: data,
              token: NVC_Opt.token
            });
          },
          fail: function fail(err) {
            if (err) {
              that.handleError(err, ERROR_TEXT.INITERROR, ERROR_TYPE.VERIFYFAIL);
            }
          }
        });
        ic.init();
      } catch (err) {
        that.handleError(err, ERROR_TEXT.INITERROR, ERROR_TYPE.INITFAIL);
      }
    },
    // 滑块初始化
    sliderInit: function sliderInit() {
      // const ncToken = [this.appkey, new Date().getTime(), Math.random()].join(
      //   ":"
      // );
      var ncToken = this.token;
      var that = this;

      try {
        var nc = NoCaptcha.init({
          // 声明滑动验证需要渲染的目标元素ID。
          renderTo: "#nc",
          // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: this.appkey,
          // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: this.scene,
          // 滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
          token: ncToken,
          // 业务键字段，可为空。为便于线上问题的排查，建议您按照线上问题定位文档中推荐的方法配置该字段值。
          trans: {},
          // 通过Dom的ID属性自动填写trans业务键，可为空。建议您按照线上问题定位文档中推荐的方法配置该字段值。
          elementID: [],
          // 是否自定义配置底层采集组件。如无特殊场景，请使用默认值（0），即不自定义配置底层采集组件。
          is_Opt: 0,
          // 语言，默认值为cn（中文）。HTML5应用类型默认支持简体中文、繁体中文、英文语言。
          language: "cn",
          // 内部网络请求的超时时间。一般情况建议保持默认值（10000ms）。
          timeout: 10000,
          // 允许服务器超时重复次数，默认5次。
          retryTimes: 5,
          // 用于自定义滑动验证各项请求的接口地址。一般情况，请勿配置该参数。
          apimap: {// 'analyze': '//a.com/nocaptcha/analyze.jsonp',
            // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
          },
          // 验证通过后，验证码组件是否自动隐藏，默认不隐藏（false）。
          bannerHidden: false,
          // 是否默认不渲染，默认值false。当设置为true时，不自动渲染，需要自行调用show方法进行渲染。
          initHidden: false,
          // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          callback: function callback(data) {
            if (data && data.csessionid) {
              data.sessionId = data.csessionid;
            }

            this.error = false;
            that.$emit("callback", null, {
              data: data,
              token: ncToken
            });
          },
          error: function error(err) {
            if (err) {
              that.handleError(err, ERROR_TEXT.INITERROR, ERROR_TYPE.VERIFYFAIL);
            }
          }
        });
        NoCaptcha.setEnabled(true); // 请务必在此处调用一次reset()方法。

        nc.reset(); // 用于配置滑动验证的自定义文案。详细信息，请参见自定义文案与多语言文档。

        NoCaptcha.upLang("cn", {
          // 加载状态提示。
          LOADING: "加载中...",
          // 等待滑动状态提示。
          SLIDER_LABEL: "请向右滑动验证",
          // 验证通过状态提示。
          CHECK_Y: "验证成功",
          // 验证失败触发拦截状态提示。
          ERROR_TITLE: "非常抱歉，这出错了"
        });
      } catch (err) {
        that.handleError(err, ERROR_TEXT.INITERROR, ERROR_TYPE.INITFAIL);
      }
    },
    // NVC初始化
    initNVC: function initNVC() {
      window.NVC_Opt = {
        // 应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey: this.appkey,
        // 使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene: this.scene,
        // 声明二次验证需要渲染的目标元素ID。
        renderTo: "#captcha",
        //业务键字段，可为空。该参数可用于上线前测试，请按照代码集成后测试部分中的方法配置该字段值。
        trans: {}
      };
    }
  }
});